module.exports = __webpack_public_path__ + "img/sleeve_ruffle_length.e3c4d3ae.png";